import AptosIcon from './logo-aptos.svg';
import BnbIcon from './logo-bnb.svg';
import KaiaIcon from './logo-kaia.svg';
import OverprotocolIcon from './logo-overprotocol.svg';
import ScallopIcon from './logo-scallop.svg';
import TetherIcon from './logo-tether.svg';
import TonIcon from './logo-ton.svg';
import WlfiIcon from './logo-wlfi.svg';

export { AptosIcon, BnbIcon, KaiaIcon, OverprotocolIcon, ScallopIcon, TetherIcon, TonIcon, WlfiIcon };
